import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../../settings/settings.service';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-obs',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './obs.component.html',
  styleUrl: './obs.component.less',
})
export class ObsComponent implements OnInit {
  @ViewChild('mensajeInput') mensajeInput: any;
  @ViewChild('obsContainer') obsContainer!: ElementRef;


  folio: string;
  pk: string;

  initials: any;
  avatar: any;
  fullname: string = '';
  hasAvatar: boolean = false;
  spinner: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { folio: string; pk: string },
    private settings: SettingsService,
    private snackBar: MatSnackBar
  ) {
    this.folio = data.folio;
    this.pk = data.pk;
  }

  ngOnInit(): void {
    this.getPersonalData();
    this.getObs();
  }


  async getPersonalData() {
    try {
      const bd: any = await this.settings.get_query(1, '/cliente-inversionista/current-user/');
      var body_data: any = bd._body;
      switch (bd.status) {
        case 201:
          this.avatar = body_data.info.user.avatar;
          this.initials =
            body_data.info.user.first_name.charAt(0) +
            body_data.info.user.last_name.charAt(0);
          this.fullname =
            body_data.info.user.first_name + ' ' + body_data.info.user.last_name;


          if (body_data.info.user.type_avatar == 0) {
            this.hasAvatar = false;
          } else {
            this.hasAvatar = true;
          }

          break;
        default:
          break;
      }
    } catch (error: any) {
      console.error('Error al obtener los datos del usuario:', error);
    }
  }

  handleError() {
    this.hasAvatar = true;
  }

  observaciones: any[] = [];
  hasObs: boolean = false;

  async getObs() {
    this.observaciones = [];
    this.hasObs = false;

    try {
      const currentUserId = localStorage.getItem('user_id');

      if (currentUserId !== null) {
        const bd: any = await this.settings.get_query(
          1,
          `/cliente-inversionista/get-observations/${this.pk}/`
        );
        var body_data: any = bd._body;

        if (bd.status === 200 || bd.status === 201) {
          var data = body_data.info.timeline; 

          console.log('data observaciones', data);

          if (data.length > 0) {
              this.observaciones = data.map((item: any) => {
                  const date = new Date(item.created_at);
                  const fechaHoraFormateada = this.formatDateTime(date); 

                  const isGenericAvatar = item.user.avatar === 'https://api.dev.api-arrayan.cl/media/profile_images/placeholder.png';
                  const [firstName, lastName] = item.user.name.split(' ');
                  const initials = `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();

                  return {
                      fechaHora: fechaHoraFormateada,
                      contenido: item.message, 
                      tipo: item.user.pk === parseInt(currentUserId, 10) ? 'der' : 'izq',
                      avatar: isGenericAvatar ? null : item.user.avatar,
                      fullname: item.user.name,
                      initials: initials,
                      hasAvatar: !isGenericAvatar
                  };
              });
              this.hasObs = true;
              this.scrollToBottom();
          } else {
              this.hasObs = false;
          }
      }
  } else {
      console.error('User ID no encontrado en localStorage');
  }
    } catch (error) {
      console.error('Error al obtener las observaciones:', error);
    }
  }

  async sendForm($event: any) {
    $event.preventDefault();
    this.spinner = true;
  
    try {
      const inputValue = this.mensajeInput.nativeElement.value.trim();
  
      if (!inputValue) {
        this.snackBar.open(
          'Por favor, ingresa una observación antes de enviar.',
          'Aceptar',
          {
            duration: 5000,
            panelClass: 'simpli-snack',
          }
        );
        return;
      }
  
      const formData = {
        observacion: inputValue,
        fullname: this.fullname,
        avatar: this.avatar ? this.avatar : null,
      };
  
      const bd: any = await this.settings.get_query(
        2,
        `/cliente-inversionista/create-observation/${this.pk}/`,
        formData
      );
      var body_data: any = bd._body;
  
      this.mensajeInput.nativeElement.value = '';
      this.getObs();
      this.scrollToBottom();
  
    } catch (error) {
      this.snackBar.open(
        'Hubo un error al enviar la observación. Intenta nuevamente.',
        'Aceptar',
        {
          duration: 5000,
          panelClass: 'simpli-snack',
        }
      );
    } finally {
      this.spinner = false;
    }
  }
  
  formatDateTime(date: Date): string {
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const anio = date.getFullYear();
    const horas = String(date.getHours()).padStart(2, '0'); 
    const minutos = String(date.getMinutes()).padStart(2, '0');

    return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
  }

  private scrollToBottom(): void {
    try {
      setTimeout(() => {
        this.obsContainer.nativeElement.scrollTop = this.obsContainer.nativeElement.scrollHeight;
      }, 100);
    } catch(err) { }
  }

}
